(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TourSheetsSearch',
	};

	// Main form element
	var $form = $('form[name=TourSheetsSearch]');
	var select;

	// Serialized form data
	var serial;
	var options;

	$(document)
	.ready(
		function documentReady() {
			Adzuki.Form.registerForm(form);
		}
	);

	form.load = function load()
	{
		$form
		.on(
			'change',
			function change(e) {
				serial = $form.serialize();

				if (e.target.id === 'toursheetssearch-tour_company_id') {
					getCountryOptions(serial);
					$form.find('#toursheetssearch-tour_sheet_id').empty();
				}

				$.each(
					options,
					function disableEmptySelects() {
						if (!$(this).val()) {
							$(this).attr('disabled', 'true');
						}
					}
				);
			}
		);

		if ($('.tour-sheet-recipient').length > 0) {
			Adzuki.Typeahead(
				'.tour-sheet-recipient',
				'/Clients/searchClientEmails',
				function select(item) {
					var email = $form.find('#toursheetssearch-recipient_email');

					email.val(item.email);
				}
			);
		}

		if ($('.tour-sheet-name').length > 0) {
			Adzuki.Typeahead(
				'.tour-sheet-name',
				'/TourSheets/searchTitles'
			);
		}

		$('#toursheetssearch-recipient, #toursheetssearch-tour_name')
			.click(
				function reset(e) {
					var container = $(this).parents('.form-group');
					container.find('input').val('');
				}
			)
		;
	};

	function getCountryOptions(serial)
	{
		Adzuki.Ajax
		.post(
			Adzuki.base_uri + '/TourSheets/getCountryOptions',
			{
				form_data: serial,
			}
		).then(
			function success(data) {
				if (data.countries) {
					setCountries(data.countries);
				}
			}
		);
	}

	function setCountries(countries) {
		select = $form.find('#toursheetssearch-country_id');
		select.empty();
		select.append($('<option>').text('Any Destination').attr('value', ''));

		toggleDisabled(select, countries);

		$.each(
			countries,
			function setCountryOptions(i, country) {
				select.append($('<option>').text(country.name).attr('value', country.id));
			}
		);
	}

	function toggleDisabled(select, options)
	{
		if (options.length < 1) {
			select.attr('disabled', 'true');
		} else {
			select.removeAttr('disabled');
		}
	}
}(jQuery, window.Adzuki || {}));
